// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import docdesEntity from './entities/docdes.json';
import docdesMenu from '../pages/docdes/menu.json';
import docdesFullForm from '../pages/docdes/forms/full.json';
import docdesContextForm from '../pages/docdes/forms/context.json';
import docdesMiniForm from '../pages/docdes/forms/mini.json';
import docdesLookupForm from '../pages/docdes/forms/lookup.json';
import docdesTableView from '../pages/docdes/views/table.json';
import docdesStagesView from '../pages/docdes/views/stages.json';
import docdesCardsView from '../pages/docdes/views/cards.json';
import docdesInlineView from '../pages/docdes/views/inline.json';
import docdesBacklogView from '../pages/docdes/views/backlog.json';
import docdesSplitView from '../pages/docdes/views/split.json';
import docdesCalendarView from '../pages/docdes/views/calendar.json';
import docdesDashboardView from '../pages/docdes/views/dashboard.json';

/** Тип запису «Тип документа» зі сторінками пакета: меню, форми та подання з pages/docdes/. */
export const docdesDefinition: IRecordTypeDefinition = {
  ...docdesEntity,
  views: assembleViewSet({
      table: docdesTableView,
      stages: docdesStagesView,
      cards: docdesCardsView,
      inline: docdesInlineView,
      backlog: docdesBacklogView,
      split: docdesSplitView,
      calendar: docdesCalendarView,
      dashboard: docdesDashboardView,
  }),
  form: docdesFullForm,
  forms: { full: docdesFullForm, context: docdesContextForm, mini: docdesMiniForm, lookup: docdesLookupForm },
  menu: docdesMenu,
} as IRecordTypeDefinition;
